export default class TipoLaudo {
    static get AGRICOLA() {
        return 1;
    }

    static get BACEN_FISCALIZACAO() {
        return 2;
    }

    static get BENFEITORIAS() {
        return 3;
    }

    static get CONFORMIDADE() {
        return 4;
    }

    static get CARBONO() {
        return 5;
    }

    static get HISTORICO_AGRICOLA() {
        return 6;
    }

    static get DIAGNOSTICO_AGRICOLA() {
        return 7;
    }

    static get SUPRESSAO_VEGETAL() {
        return 8;
    }

    static get TECNICO_AGRICOLA() {
        return 9;
    }

    static get CROQUI() {
        return 10;
    }

    static get BACEN_140() {
        return 11;
    }

    static get AVALIACAO_FUNDIARIA() {
        return 12;
    }

    static get AVALIACAO_DE_AREA_PRODUTIVA() {
        return 13;
    }

    static get AVALIACAO_SOCIOAMBIENTAL() {
        return 14;
    }

    static get RENOVABIO() {
        return 15;
    }

    static get RELATORIO_TERRITORIAL() {
        return 16;
    }

    static get ANALISE_DE_COBERTURA_DE_SOLO() {
        return 17;
    }

    static get MUT_E_PASTAGEM() {
        return 18;
    }

    static getByName(name) {
        if (!name) return;
        name = name.toUpperCase();
        return TipoLaudo[name];
    }
}
